import axios from "axios";
import { useEffect, useState } from "react";
import { MdArrowBack, MdEdit, MdEmail, MdFormatQuote, MdMenuBook, MdMobileFriendly, MdPerson, MdPersonPinCircle, MdVideoCameraBack } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useMediaQuery } from "react-responsive";
import { web_url } from "../../constant";

const url = "http://localhost:8080/api/";
function ResearcherEditProfile({ t, language }) {
    const isXlOrLarger = useMediaQuery({ minWidth: 1270 });
    const navigate = useNavigate();

    const [details, setDetails] = useState(() => {
        const getLogDetails2 = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails2 = getLogDetails2();
        return {
            namePerm: localStorage.getItem('name'),
            name: localStorage.getItem('name'),
            mobile: localStorage.getItem('mobile'),
            mobilePerm: localStorage.getItem('mobile'),
            email: logDetails2.email
        }
    })

    const config2 = {
        borderRadius: '8px',
        language: 'en',
        width: '330px',
        height: '250px',
        objectFit: 'contain',
        compressInitial: null,
        darkMode: false,
        rtl: false
    };


    const [errors, setErrors] = useState(
        {
            noName: false,
            invalidName: false,
            noMobile: false,
            invalidMobile: false
        }
    )

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const [open2, setOpen2] = useState(false);

    const handleClickOpen2 = () => {
        setOpen2(true);
    };

    const handleClose2 = () => {
        setOpen2(false);
        if (isXlOrLarger) {
            navigate('/desktop/researcher/settings')
        } else {
            navigate('/mobile/researcher/settings')
        }
    };

    const [openError, setOpenError] = useState(false);
    const [error, setError] = useState('');

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setError(t('t93'));
        } else {
            setError(t('t94'));
        }
        setOpenError(true);
    };

    const handleCloseError = () => {
        setOpenError(false);
        navigate('/loginas')
    };

    const handleContinue = () => {
        // console.log(details);
        const nameRegex = /^[^\d]*$/;
        const mobileRegex = /^07\d{8}$/;
        let newErrors = {};

        newErrors.noName = !details.name;
        newErrors.noMobile = !details.mobile;

        if ((details.name) && !nameRegex.test(details.name)) {
            newErrors.invalidName = true;
        } else {
            newErrors.invalidName = false;
        }

        if (details.mobile && !mobileRegex.test(details.mobile)) {
            newErrors.invalidMobile = true;
        } else {
            newErrors.invalidMobile = false;
        }


        setErrors(newErrors);

        if (Object.values(newErrors).some((error) => error)) {
            return;
        }
        handleClickOpen(true);
    }

    const [isLoading, setIsLoading] = useState(false);

    const handleChange = () => {
        if (details.namePerm !== details.name || details.mobilePerm !== details.mobile) {
            const detailsNow = {
                userFullName: details.name,
                contactNumber: details.mobile
            };
            setIsLoading(true);
            const getLogDetails = () => {
                return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
            };
            const logDetails = getLogDetails();

            const apiUrl = `${url}auth/researchers/${logDetails.email}`
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${logDetails.token}`,
                },
            };
            // axios.post(apiUrl, teacher, config)
            axios.patch(`${web_url}/api/auth/researchers/${logDetails.email}`, detailsNow, config)
                .then((response) => {
                    console.log("updated successfully");
                    setIsLoading(false);
                    localStorage.setItem('name', response.data.userFullName);
                    localStorage.setItem('mobile', response.data.contactNumber);
                    setOpen(false);
                    handleClickOpen2();
                })
                .catch((err) => {
                    if (err.response) {
                        if (err.response.data.error) {
                            handleClickOpenError(err.response.data.error);
                        } else if (err.response.data.message) {
                            handleClickOpenError(err.response.data.message);
                        } else {
                            handleClickOpenError("An unknown error occured");
                        }

                    } else if (err.request) {
                        const errorMessage = "No response from the server. Please check your network connection.";
                    } else {
                        const errorMessage = err.message;
                    }
                    setIsLoading(false);
                })
        }else{
            setIsLoading(false);
            setOpen(false);
            handleClickOpen2();
        }

    }

    return (
        <div className="pl-[30px] pr-[30px] md:items-center pt-[80px] md:pt-[120px] lg:pt-[140px] xl:pt-[10px] 2xl:pt-[20px]">
            <div className="flex items-center justify-start mt-[20px] lg:ml-[70px]">
                <MdArrowBack size={25} className="md:hidden" onClick={() => {
                    navigate('/mobile/researcher/settings')
                }} />
                <MdArrowBack size={30} className="hidden md:block xl:hidden" onClick={() => {
                    navigate('/mobile/researcher/settings')
                }} />
                <p className="text-[20px] ml-[10px] md:text-[23px] lg:text-[25px] xl:text-[19px] 2xl:text-[25px]">{t('t154')}</p>
            </div>

            {/* <div className="lg:ml-[180px] md:ml-[100px] xl:ml-[100px] 2xl:ml-[150px] items-center mt-[30px] xl:mt-[10px] 2xl:mt-[50px] flex rounded-md w-full xl:w-[500px] 2xl:w-[600px] md:w-[600px] bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400"> */}
            <div className="xl:mt-[30px] flex flex-col items-center justify-center">
                <div className="items-center mt-[30px] xl:mt-[10px] 2xl:mt-[50px] flex rounded-md w-full xl:w-[500px] 2xl:w-[600px] md:w-[600px] bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                    <MdEmail size="24px" color="#8189B0" />
                    <input type="text" disabled value={details.email} name="name" className="ml-[10px] w-full xl:w-[450px] bg-[#F1F6FB] text-[15px] md:text-[17px] text-gray-600 placeholder:text-[#8189B0] focus:outline focus:outline-0" placeholder={t('t27')}
                    />
                </div>

                <div className="items-center mt-[20px] xl:mt-[10px] 2xl:mt-[20px] flex rounded-md w-full xl:w-[500px] 2xl:w-[600px] md:w-[600px] bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                    <MdPerson size="24px" color="#8189B0" />
                    <input type="text" value={details.name} name="email" className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] md:text-[17px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0" placeholder={t('t27')}
                        onChange={(e) => {
                            setDetails((prevState) => ({
                                ...prevState, name: e.target.value
                            }))
                        }}
                    />
                </div>

                <div className="flex w-full xl:w-[500px] 2xl:w-[600px] md:w-[600px] items-center justify-start">
                    {errors.noName &&
                        <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t29')}</p>
                    }

                    {errors.invalidName &&
                        <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t28')}</p>
                    }
                </div>

                <div className="items-center mt-[20px] xl:mt-[10px] 2xl:mt-[20px] flex rounded-md w-full xl:w-[500px] 2xl:w-[600px] md:w-[600px] bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                    <MdMobileFriendly size="24px" color="#8189B0" />
                    <input type="text" name="mobile" value={details.mobile} className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0" placeholder={t('t57')}
                        onChange={(e) => {
                            setDetails((prevState) => ({
                                ...prevState, mobile: e.target.value
                            }))
                        }}
                    />
                </div>
                <div className="flex w-full xl:w-[500px] 2xl:w-[600px] md:w-[600px] items-center justify-start">
                    {errors.noMobile &&
                        <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t58')}</p>
                    }

                    {errors.invalidMobile &&
                        <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t59')}</p>
                    }
                </div>
            </div>
            <div className=" flex justify-center mt-[20px] md:mt-[20px] lg:mt-[30px] xl:mt-[10px] xl:mb-[50px] 2xl:mt-[30px] ">
                <div className="w-full xl:w-[500px] 2xl:w-[600px] md:w-[600px] flex justify-center gap-[30px]">
                    <button onClick={() => {
                        if (isXlOrLarger) {
                            navigate('/desktop/researcher/settings')
                        } else {
                            navigate('/mobile/researcher/settings')
                        }
                    }} className="w-[45%] bg-[#F2AC0E] text-black px-[20px] py-[10px] md:py-[15px] 2xl:py-[15px]  rounded-md">{t('t145')}</button>
                    <button onClick={handleContinue} className="w-[45%] bg-[#F2AC0E] text-black px-[20px] py-[10px] md:py-[15px] 2xl:py-[15px] rounded-md">{t('t146')}</button>
                </div>

            </div>

            <Dialog
                open={openError}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleCloseError(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    {t('t95')}
                </DialogTitle>
                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {error}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleCloseError}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm md:mr-[0px]"
            >
                <DialogContent className="bg-[#FFF6DA]">

                    <DialogContent
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        <div className='flex flex-col justify-center items-center text-center'>
                            {
                                isLoading ?
                                    <div className="items-center justify-center flex">
                                        <div className='w-10 h-10 border-2 border-t-transparent border-[#F2AC0E] rounded-full animate-spin'></div>
                                    </div>
                                    : <>
                                        <div className='mt-[0px]'>{t('t166')}</div>
                                        <div className="flex justify-center item-center gap-[20px] mt-[20px]">
                                            <Button
                                                onClick={handleClose}
                                                className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md mt-[10px]"
                                                style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                            >
                                                {t('t145')}
                                            </Button>
                                            <Button
                                                onClick={() => { handleChange() }}
                                                className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md mt-[10px]"
                                                style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                            >
                                                {t('t144')}
                                            </Button>
                                        </div>
                                    </>
                            }
                        </div>
                    </DialogContent>
                </DialogContent>
            </Dialog>


            <Dialog
                open={open2}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose2(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm md:mr-[0px]"
            >
                <DialogContent className="bg-[#FFF6DA]">

                    <DialogContent
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        <div className='flex flex-col justify-center items-center text-center'>
                            <div className='mt-[0px]'>{t('t165')}</div>
                            <div className="flex justify-center item-center gap-[20px] mt-[20px]">
                                <Button
                                    onClick={handleClose2}
                                    className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md mt-[10px]"
                                    style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                >
                                    {t('t7')}
                                </Button>
                            </div>

                        </div>
                    </DialogContent>
                </DialogContent>
            </Dialog>
        </div>
    )
}

export default ResearcherEditProfile;